module.exports = __webpack_public_path__ + "img/page_bottom_bg.3a27d599.png";